<template>
  <div class="navbar">
    <div class="sidebar-logo-container">
      <img
        v-if="logoTheme == 'cts'"
        class="sidebar-logo"
        :src="logo"
        @click="toHomepage()"
        alt=""
      />
      <img
        v-if="logoTheme == 'dv'"
        class="sidebar-logo"
        :src="logoDvImg"
        @click="toHomepage()"
        alt=""
      />
    </div>
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
          <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="hover"
      >
        <div class="avatar-wrapper">
         <svg-icon icon-class="face" style="margin-right:10px;width:30px;height:30px;vertical-align:-8px "></svg-icon>
          <span>{{ userInfo.userNameCn }}</span>
          <!-- <i class="el-icon-caret-bottom" /> -->
        </div>
        <el-dropdown-menu slot="dropdown">
        <!--   <router-link to="/profile/index">
            <el-dropdown-item>{{ $t("system.profile") }}</el-dropdown-item>
          </router-link> -->
          <!-- <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link>
          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">{{ $t("system.logOut") }}</span>
          </el-dropdown-item>
          <el-dropdown-item>
             <span @click="forgetPasswordVisible"
              >{{ $t("navbar.changePassword") }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- 页面刷新 -->
        <!-- <div @click="refresh" class="right-menu-item hover-effect" >
          <el-tooltip effect="dark" :content="$t('navbar.refresh')" placement="bottom">
            <i style="margin-top: 15px;color:#ffffff" class="el-icon-refresh-left"></i>
          </el-tooltip>
        </div> -->
        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->
        <!-- <el-tooltip
          effect="dark"
          :content="$t('navbar.langSelect')"
          placement="bottom"
        >
          <lang-select class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <el-tooltip
          effect="dark"
          :content="$t('navbar.fullscreen')"
          placement="bottom"
        >
          <screenfull class="right-menu-item hover-effect" id="screenfull" />
        </el-tooltip>
        <!-- 消息中心 -->
        <!-- <div class="btn-bell right-menu-item hover-effect">
          <el-tooltip
            effect="dark"
            :content="message?message+$t('navbar.messageDetail'):$t('navbar.message')"
            placement="bottom"
          >
            <router-link to="/messageManage">
              <i class="el-icon-bell" style="color:#ffffff"></i>
            </router-link>
          </el-tooltip>
          <span class="btn-bell-badge">
            <span class="num">{{message}}</span>
          </span>
        </div> -->

        <!--        <el-tooltip content="Global Size" effect="dark" placement="bottom">-->
        <!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
        <!--        </el-tooltip>-->
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
import LangSelect from "@/components/LangSelect/LangSelect.vue";
import SizeSelect from "@/components/SizeSelect";
import Search from "@/components/HeaderSearch";

export default {
  data() {
    return {
      message: 2,
      logo: require("../../assets/images/home_imgs/logo.png"),
      logoDvImg: require("../../assets/images/login_imgs/logoDv.png"),
      userInfo: "",
      logoTheme: "cts",
    };
  },
  components: {
    //Breadcrumb,
    Hamburger,
    // ErrorLog,
    Screenfull,
    LangSelect,
    // SizeSelect,
    // Search
  },
  inject: ["reload"],
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"]),
  },
  mounted() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    }

    if (localStorage.getItem("logoTheme")) {
      this.logoTheme = localStorage.getItem("logoTheme");
    }
  },
  methods: {
    refresh() {
      this.reload();
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      /* this.$cookies.remove('languageChange') */
    },
    toHomepage() {
      this.$router.push(`/home/homePage?redirect=${this.$route.fullPath}`);
    },
    forgetPasswordVisible() {
      this.$emit("forgetPassword", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  color: #333 !important;
  // background: #fff;
  background: #fff;
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    // background: #2E88FF!important;
    margin-left: 30px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      margin-right: 10px;
      color: #5a5e66;
      vertical-align: text-bottom;
      // background-color: red;
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        color: rgba(89, 89, 89, 1);
        font-size: 14px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.el-icon-refresh-left:before {
  font-size: 20px;
  font-weight: bold;
}
.btn-bell-badge {
  position: absolute;
  right: 114px;
  top: 1px;
  width: 24px;
  height: 17px;
  border-radius: 10px;
  background: #f56c6c;
  .num {
    position: absolute;
    display: block;
    width: 100%;
    text-align: center;
    font-size: 12px;
    top: -16px;
    color: #fff;
  }
}
.btn-bell .el-icon-bell {
  font-size: 20px;
  font-weight: bold;
}
.sidebar-logo-container {
  float: left;
  height: 50px;
  line-height: 50px;
  text-align: center;
  overflow: hidden;
  width: 110px !important;
  // background-color: #4AB4FE;
  & .sidebar-logo {
    width: 55px;
    height: 31px;
    vertical-align: middle;
    margin-right: 12px;
  }
}
</style>
